import React from 'react'
import {
  AiFillGithub,
  AiFillLinkedin,
  AiFillTwitterCircle,
} from 'react-icons/ai'
import { SiHashnode } from 'react-icons/si'
import { Link } from 'react-router-dom'
import classes from './form.module.css'

export const Form = () => {
  return (
    <div className={classes.container}>
      <div className={classes.left}>
        <div className={classes.contact_group}>
          <span className={classes.big}>Kelvin </span>
          <span className={classes.small}>Adamawa, Nigeria</span>
        </div>
        <div className={classes.contact_group}>
          <span className={classes.big}>Email </span>
          <span className={classes.small}>moseskelvin4u@gmail.com</span>
        </div>
        <div className={classes.social}>
          <span>
            <Link to="https://www.linkedin.com/in/iamkelv/">
              <AiFillLinkedin />
            </Link>
            <Link to="https://www.linkedin.com/in/iamkelv/">
              <AiFillTwitterCircle />
            </Link>
            <Link to="https://github.com/iamkelv">
              <AiFillGithub />
            </Link>
            <Link to={'https://iamkelv.hashnode.dev/'}>
              <SiHashnode />
            </Link>
          </span>
        </div>
      </div>
      <div className={classes.right}>
        <form
          className={classes.form}
          action="https://formsubmit.co/moseskelvin4u@gmail.com"
          method="POST"
        >
          <input type="hidden" name="_subject" value="Porfolio Contact form!" />
          <input
            type="hidden"
            name="_autoresponse"
            value="Thank you for Contacting me. I will get back as soon as possible"
          />
          <input
            type="hidden"
            name="_next"
            value="http://localhost:3000/thank-you"
          ></input>
          <input type="hidden" name="_captcha" value="false" />
          <div className={classes.form_group}>
            <input type="text" name="name" required placeholder="Full Name" />
          </div>
          <div className={classes.form_group}>
            <input type="email" placeholder="Email" name="email" required />
          </div>
          <div className={classes.form_group}>
            <textarea
              placeholder="Message"
              cols="30"
              name="message"
              rows="10"
            ></textarea>
          </div>
          <div className={classes.form_btn}>
            <button type="submit">Send</button>
          </div>
        </form>
      </div>
    </div>
  )
}
